var map = {
	".": 1454,
	"./": 1454,
	"./copy": 785,
	"./copy.data": 7661,
	"./copy.data.ts": 7661,
	"./copy.ts": 785,
	"./copy.types": 9526,
	"./copy.types.ts": 9526,
	"./global": 3100,
	"./global.ts": 3100,
	"./index": 1454,
	"./index.ts": 1454,
	"./translations/en/aboutPage": 999,
	"./translations/en/aboutPage.json": 999,
	"./translations/en/contactPage": 9166,
	"./translations/en/contactPage.json": 9166,
	"./translations/en/footer": 9191,
	"./translations/en/footer.json": 9191,
	"./translations/en/global": 7342,
	"./translations/en/global.json": 7342,
	"./translations/en/head": 7420,
	"./translations/en/head.json": 7420,
	"./translations/en/header": 9197,
	"./translations/en/header.json": 9197,
	"./translations/en/indexPage": 784,
	"./translations/en/indexPage.json": 784,
	"./translations/en/notFoundPage": 3175,
	"./translations/en/notFoundPage.json": 3175,
	"./translations/en/privacyPage": 2083,
	"./translations/en/privacyPage.json": 2083,
	"./translations/en/processPage": 348,
	"./translations/en/processPage.json": 348,
	"./translations/en/projects": 2193,
	"./translations/en/projects.json": 2193,
	"./translations/en/servicesPage": 8335,
	"./translations/en/servicesPage.json": 8335,
	"store": 1454,
	"store/": 1454,
	"store/copy": 785,
	"store/copy.data": 7661,
	"store/copy.data.ts": 7661,
	"store/copy.ts": 785,
	"store/copy.types": 9526,
	"store/copy.types.ts": 9526,
	"store/global": 3100,
	"store/global.ts": 3100,
	"store/index": 1454,
	"store/index.ts": 1454,
	"store/translations/en/aboutPage": 999,
	"store/translations/en/aboutPage.json": 999,
	"store/translations/en/contactPage": 9166,
	"store/translations/en/contactPage.json": 9166,
	"store/translations/en/footer": 9191,
	"store/translations/en/footer.json": 9191,
	"store/translations/en/global": 7342,
	"store/translations/en/global.json": 7342,
	"store/translations/en/head": 7420,
	"store/translations/en/head.json": 7420,
	"store/translations/en/header": 9197,
	"store/translations/en/header.json": 9197,
	"store/translations/en/indexPage": 784,
	"store/translations/en/indexPage.json": 784,
	"store/translations/en/notFoundPage": 3175,
	"store/translations/en/notFoundPage.json": 3175,
	"store/translations/en/privacyPage": 2083,
	"store/translations/en/privacyPage.json": 2083,
	"store/translations/en/processPage": 348,
	"store/translations/en/processPage.json": 348,
	"store/translations/en/projects": 2193,
	"store/translations/en/projects.json": 2193,
	"store/translations/en/servicesPage": 8335,
	"store/translations/en/servicesPage.json": 8335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3770;